import { Encodings, Font, FontNames } from "@pdf-lib/standard-fonts"
import { Scale } from "@pdfking/math"

import type { Measure } from "#internal"

// A standard font's widths are in thousandths of its size
const UNITS = 1000

// How wide a text is in the one font pages plot with, by the font's own
// metrics — the standard Helvetica every pdf carries, which is what the
// renderer sets the text in — so a layout comes out the same wherever it is
// made, and the words land where they were measured to. A character the font
// has no glyph for is as wide as nothing: the renderer draws none for it
// either
export const CreateMeasure = (): Measure => {
  const font = Font.load(FontNames.Helvetica)
  const { WinAnsi } = Encodings
  const width = (text: string) => {
    let total = 0
    for (const char of text) {
      const point = char.codePointAt(0)!
      if (WinAnsi.canEncodeUnicodeCodePoint(point))
        total += font.getWidthOfGlyph(WinAnsi.encodeUnicodeCodePoint(point).name) ?? 0
    }
    return total
  }
  return (text, size) => Scale(size, width(text) / UNITS)
}
